import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-privacy",
  templateUrl: "./privacy.component.html",
  styleUrls: ["./privacy.component.scss"],
})
export class PrivacyComponent implements OnInit {
  constructor(private seoService: SeoServiceService) {}

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
  }
}
